import MainComponent from "components/Main";
import SelectComplite from "components/SelectComplite";

import './themes/default.less';

const date = new Date();
const currentYear = date.getFullYear();

export default class SelectDate extends MainComponent {
    constructor(props) {
        super(props);

        const defaultDate = props.currentday ? this._helper.date.fromStr(props.currentday) : null;
        const defaultDay = defaultDate ? defaultDate.getDate() : null;
        const defaultMonth = defaultDate ? defaultDate.getMonth() + 1 : null;
        const defaultYear = defaultDate ? defaultDate.getFullYear() : null;

        this.years = new Array(100).fill(0).map((it, i) => {
            const n = currentYear - i;
            return { id: n, name: `${n}` };
        });

        this.days = this.getDays(31);

        this.state = {
            selectedDate: defaultDay,
            selectedMonth: defaultMonth,
            selectedYear: defaultYear,
            days: this.getDays(31),
            years: this.years,
        };

        this.months = new Array(12).fill(0).map((it, i) => {
            const newDate = new Date(date.getFullYear(), i, 1);
            const name = this._helper.date.toStr(newDate, "MMMM");
            return { id: i + 1, name: this._helper.string.capitalize(name) };
        });

    }

    set value(value) {
        this.state.selectedDate = value.day;
        this.state.selectedMonth = value.month + 1;
        this.changeState("selectedYear", value.year);
    }

    setDate() {
        const { selectedDate, selectedMonth, selectedYear } = this.state;

        const selDate = new Date(selectedYear, selectedMonth - 1, selectedDate);

        if (this.props.onClick?.apply)
            this.props.onClick((selectedDate && selectedMonth && selectedYear) ? this._helper.date.toStr(selDate) : false);
    }

    getDays(daysInMonth) {
        return new Array(daysInMonth).fill(0).map((it, i) => { return { id: i + 1, name: `${i + 1}` }; });
    }

    changeDays(month, year) {
        let { selectedDate } = this.state;

        const currentDate = this._helper.date.create();
        currentDate.setMonth(month - 1);
        currentDate.setFullYear(year || currentYear);

        const daysInMonth = this._helper.date.getMonthDaysCount(currentDate);
        const days = this.getDays(daysInMonth);

        if (selectedDate > daysInMonth)
            selectedDate = daysInMonth;

        this.days = days;
        this.setState({ days, selectedDate });

        if (selectedDate && month && year && this.props.onChange?.apply) {
            const m = month < 10 ? `0${month}` : month;
            const d = selectedDate < 10 ? `0${selectedDate}` : selectedDate;
            const currDate = this._helper.date.toStr(`${year}-${m}-${d}`);
            this.props.onChange(currDate);
        }
    }

    handleMonthChange(selected) {
        const { selectedYear } = this.state;
        this.state.selectedMonth = selected;
        this.changeDays(selected, selectedYear);
        this.setDate();
    }

    handleYearChange(selected, value) {
        const { selectedMonth } = this.state;
        this.state.selectedYear = selected;
        this.changeDays(selectedMonth, selected);
        this.setDate();

        if (value)
            this.changeState("years", this.years.filter(it => it.name.includes(value)));
        else
            this.changeState("years", this.years);
    }

    handleDayChange(selected, value) {
        this.state.selectedDate = selected;
        this.setDate();

        if (value)
            this.changeState("days", this.days.filter(it => it.name.includes(value)));
        else
            this.changeState("days", this.days);
    }

    render() {
        const { selectedDate, selectedMonth, selectedYear, days, years } = this.state;

        return (
            <div className="selectDate flex col gap8">
                <div className="titleDate text p2">
                    {this.tr("main.dateBirth")}
                </div>
                <div className="flex flex1 gap4 flex4">
                    <SelectComplite
                        value={selectedDate}
                        placeHolder={"main.dd"}
                        showLeftIcon={false}
                        items={days}
                        onChangeInput={this.handleDayChange.bind(this)}
                    />
                    <SelectComplite
                        value={selectedMonth}
                        placeHolder={"main.mm"}
                        showLeftIcon={false}
                        items={this.months}
                        onChangeInput={this.handleMonthChange.bind(this)}
                    />
                    <SelectComplite
                        value={selectedYear}
                        placeHolder={"main.yyyy"}
                        showLeftIcon={false}
                        items={years}
                        onChangeInput={this.handleYearChange.bind(this)}
                    />
                </div>
            </div>

        );
    }
}
